import React from 'react';

import iconFacebook from '../../images/icon-facebook.svg';
import iconInstagram from '../../images/icon-instagram.svg';
import iconTwitter from '../../images/icon-twitter.svg';
import iconPatreon from '../../images/icon-patreon.svg';
import iconYoutube from '../../images/icon-youtube.svg';

const socialLinks = [
  { href: 'https://www.facebook.com/lineagejourney/', icon: iconFacebook, alt: 'Facebook' },
  { href: 'https://www.instagram.com/lineagejourney/', icon: iconInstagram, alt: 'Instagram' },
  { href: 'https://twitter.com/lineagejourney', icon: iconTwitter, alt: 'Twitter' },
  { href: 'https://www.patreon.com/lineagejourney', icon: iconPatreon, alt: 'Patreon' },
  { href: 'https://www.youtube.com/channel/UChwz5_GZN655houtFoVKQ7w', icon: iconYoutube, alt: 'Youtube' },
];

export default function SocialLinks({ className = '' }) {
  return (
    <ul className={`social-links ${className}`}>
      {socialLinks.map((link) => (
        <li key={link.alt}>
          <a href={link.href} target="_blank" rel="noopener noreferrer">
            <img src={link.icon} alt={link.alt} />
          </a>
        </li>
      ))}
    </ul>
  );
}
